module.exports = __webpack_public_path__ + "img/top.9b50766e.jpg";